import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';

const useRouter = <Params = any>() => {
  const history = useHistory();
  const location = useLocation();
  const params: Params = useParams();
  const match = useRouteMatch();

  return {
    history,
    location,
    params,
    match,
  };
};

export default useRouter;
